import React from 'react';
import PropTypes from 'prop-types';

import { Box } from './Boneyard';

const propTypes = {
  children: PropTypes.node,
};

const HorizontallyAlign = ({ children, ...props }) => (
  <Box {...props} d="flex" alignItems="center">
    {children}
  </Box>
);
HorizontallyAlign.propTypes = propTypes;

export default HorizontallyAlign;
